module.exports = {
	methods: {
		reset()
		{
			$('#confirmationRestartModal').modal('toggle');
		}
	}
}